import {
  LeftJustifiedInsuranceTermsLink,
  LeftJustifiedIpidLinks,
} from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.styles";
import { AdviceCoverageName, SinglePayment } from "Store/advice/interfaces";
import { useInsuranceCoverages, useProductTexts } from "Store/texts/hooks";
import React, { useState } from "react";
import { Description, ProductCoverageContainer } from "../../adviceStyled";
import { getAdviceInsuranceType } from "./utils";

import { WrapLgMarginBottom } from "App/global-style";
import CollapsibleContainer from "Components/CollapsibleContainer";
import { CoverageCardAccordion } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/CoverageCardAccordion";
import { getInsuranceTypeCoverages } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.helpers";
import { CoverageInfo } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/productPriceTile.styles";
import { ThemedButton } from "Components/Themes/components/ThemedButton";
import { ProductBackendName } from "Features/CheckPrice/Products/productTypes";
import { useIsAdvisorSelector } from "Store/advisor/advisorSelectors";
import { PaymentConfiguration } from "Store/akaAdvice/interfaces/CollectiveAdvice";
import { getFMSProductName } from "Store/texts/helpers/FMSproductName";
import { buttonTrackId } from "Utils/analytics";
import { useWindowSize } from "Utils/screenSizeUtils";
import { PayoutInformation } from "./PayoutInformation";

interface Props {
  selected: boolean;
  title?: string;
  description?: string;
  readableInsuranceType: string;
  backendInsuranceName: ProductBackendName;
  coverageGroup?: AdviceCoverageName;
  disabilityOneTimePayment?: SinglePayment | PaymentConfiguration;
}
export const ProductCoverages = ({
  selected,
  title,
  description,
  readableInsuranceType,
  backendInsuranceName,
  coverageGroup,
  disabilityOneTimePayment,
}: Props): React.ReactElement | null => {
  const isAdvisor = useIsAdvisorSelector();
  const windowSize = useWindowSize();
  const mobileVariant = windowSize.width ? windowSize.width < 540 : false;

  const [
    {
      formText: {
        advice: { productCoverage },
      },
    },
    lang,
  ] = useProductTexts(getFMSProductName(ProductBackendName.ADVICE));
  const coverageTexts = useInsuranceCoverages(backendInsuranceName);
  const [showDetails, toggleDetails] = useState(false);
  const handleToggleDetails = (): void => {
    toggleDetails(!showDetails);
  };

  if (!coverageGroup) {
    return null;
  }

  const insuranceType = getAdviceInsuranceType(
    coverageGroup,
    isAdvisor,
    disabilityOneTimePayment,
  );
  const includedCoverages = getInsuranceTypeCoverages(
    coverageTexts,
    insuranceType,
  );

  return (
    <>
      <CoverageInfo selected={selected}>
        <ThemedButton
          variant="text"
          trackId={buttonTrackId(productCoverage.titleCoverage["en"])}
          onClick={handleToggleDetails}
          iconRight={showDetails ? "chevron-up" : "chevron-down"}
        >
          {title ?? productCoverage.titleCoverage[lang]}
        </ThemedButton>
      </CoverageInfo>
      <CollapsibleContainer isOpen={showDetails}>
        <ProductCoverageContainer>
          {includedCoverages && (
            <>
              <Description fw={700} size={"16px"}>
                {description ??
                  `${readableInsuranceType} ${productCoverage.covers[lang]}:`}
              </Description>
              <WrapLgMarginBottom style={{ width: "100%" }}>
                <CoverageCardAccordion
                  cardId={String(coverageGroup)}
                  coverages={includedCoverages}
                  includedCoverages
                  lang={lang}
                />
              </WrapLgMarginBottom>
            </>
          )}
          <PayoutInformation insuranceType={insuranceType} />
          <LeftJustifiedIpidLinks
            coverage={coverageGroup}
            isOnColoredBackground={selected}
            useShortText={mobileVariant}
          />
          <LeftJustifiedInsuranceTermsLink
            productBackendName={backendInsuranceName}
            isOnColoredBackground={selected}
          />
        </ProductCoverageContainer>
      </CollapsibleContainer>
    </>
  );
};
